var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bb-button bb-description-3 bb-bold bb-fcenter",class:{ '--selected': _vm.currentPage === _vm.page },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.page)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }